<script lang="ts">
	import Katex from './Katex.svelte'
	import brackets from './functions/brackets'
	import Word from './functions/wordClass'
	import getRandomIntArray from './functions/getRandomIntArray'
	import getRandomInt from './functions/getRandomInt'
	import {word} from './stores';

	let wordSC: string, consonants: string, vowels: string;
	$: wordSC = $word.toUpperCase();	
	let wordObject: Word;
	$: wordObject = new Word($word);
	$: consonants = wordObject.consonants.toString();
	$: vowels = wordObject.vowels.toString();
	let letter1: string, letter2: string, letters12: string[];
	$: letters12 = chooseSingle(wordObject);
	$: letter1 = letters12[0];
	$: letter2 = letters12[1];
	let letterRepeat: string;
	$: letterRepeat = chooseRepeat(wordObject);
	let inBetween: number, marks: number;
	$: if (wordObject.triples.length > 0 && wordObject.length % 2 == 1){
		marks = 4;
	} else{
		marks = 3;
	}
	$: if (wordObject.triples.length==0){
		inBetween = wordObject.length - 3;
	} else{
		inBetween = Math.ceil((wordObject.length-3)/2-1);
	}
	let marksBi: number, marksBii: number
	$: if (wordObject.repeats.length>0){
		marksBi = 3;
		marksBii = 3;
		if (wordObject.triples.length>0){
			marksBii = 4;
		}
	} else{
		marksBi = 2;
		marksBii = 2;
	}

	function chooseSingle(w: Word):string[]{
		const n = w.singles.length;
		const index = getRandomIntArray(0,n-1,2);
		return [w.singles[index[0]], w.singles[index[1]]];
	}

	function chooseRepeat(w:Word):string{
		if (w.triples.length>0){ // choose triple if allowed
			const n = w.triples.length;
			const index = getRandomInt(0,n-1);
			return w.triples[index];
		} else{ // choose double
			const n = w.doubles.length;
			const index = getRandomInt(0,n-1);
			return w.doubles[index];
		} 
	}
</script>

<div>
	<p>
		(a) Find the number of ways in which the letters of the word
		<Katex math={wordSC}/> can be arranged if
	</p>
	<div style="margin-left:1rem">
		<p>(i) (1 mark) there are no restrictions,</p>
		<p>
			(ii) (2 marks) <Katex math={letter1}/>
			and <Katex math={letter2}/> must not be next to one another,
		</p>
		{#if wordObject.doubles.length>0 || wordObject.triples.length>0}
			<p>
				(iii) ({marks} marks) between
				{#if wordObject.triples.length>0}
					any
				{:else}
					the
				{/if}
				two <Katex math={letterRepeat}/>s
				there must be at least {inBetween} other letters
			</p>
		{/if}
		{#if wordObject.vowelConsonantDiff < 2}
			<p>
				{#if wordObject.doubles.length >0 || wordObject.triples.length>0}
					(iv)
				{:else}
					(iii)
				{/if}
				(3 marks) consonants (<Katex math={consonants}/>)
				and vowels (<Katex math={vowels}/>) must alternate.
			</p>
		{/if}
	</div>
	
	<div>
		<p>
			(b) Each letter in <Katex math={wordSC}/> is printed on individual cards
			such that cards containing the same letter are considered identical. A "codeword" is formed by using some of these cards in a certain order.
		</p>
		<div style="margin-left:1rem">
			<p>(i) ({marksBi} marks) Find the number of possible "codewords" that can be formed with 3 cards.</p>
			{#if wordObject.length > 3}
				<p>
					(ii) ({marksBii} marks) Find the number of possible "codewords" that can be formed with 4 cards.
				</p>
			{/if}
		</div>
	</div>
</div>	